import { Select, Spin } from "antd";
import React, { memo, useCallback, useState } from "react";
import { apiUser } from "../../../../api/api-users";

const { Option } = Select;

const KeToan = ({ setFieldsValue, name }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const onSearch = (value) => {
    setLoading(true);

    const filters = {
      department: {
        id: 3,
      },
      name: `%${value
        .trim()
        .replace(/(\r\n|\n|\r)/gm, " ")
        .replace(/%/gi, "\\%")}%`,
      // user_role: { id_in: [1, 2] },
      active: true,
    };

    apiUser
      .getUsers(filters, 1)
      .then((res) => {
        if (res.status === "success") {
          setOptions(
            res.data.content.map((i) => ({ value: i.id, label: i.name }))
          );
        }
      })
      .finally(() => setLoading(false));
  };

  const onChange = useCallback((values) => {
    !!setFieldsValue &&
      setFieldsValue({
        vehicle: {
          [name]: {
            id_in: values.length > 0 ? values.map((i) => i.value) : null,
          },
        },
      });
  }, []);

  return (
    <Select
      mode="multiple"
      showArrow
      placeholder="Kế toán"
      labelInValue
      notFoundContent={loading ? <Spin size="small" /> : null}
      filterOption={false}
      onChange={onChange}
      onSearch={onSearch}
    >
      {options.map((item, index) => (
        <Option key={index} value={item.value}>
          {item.label}
        </Option>
      ))}
    </Select>
  );
};

export default memo(KeToan);
